import { useMemo } from "react";

import { useQuery } from "@apollo/client";
import classNames from "classnames";
import { Spinner } from "react-bootstrap";

import Modal from "components/common/Modal";

import useModal from "hooks/useModal";

import ALL_CHANGELOGS from "@gql/sanity/allChangelogs";

export const ANNOUNCEMENTS_MODAL_NAME = "ANNOUNCEMENTS_MODAL";

const itemTypeMap = {
  fix: "NEW",
  improvement: "IMPROVE",
  bug: "FIX",
};

const AnnouncementsModal = () => {
  const { close } = useModal(ANNOUNCEMENTS_MODAL_NAME);

  const { data, loading } = useQuery(ALL_CHANGELOGS, {
    variables: { sort: [{ date: "ASC" }] },
  });

  const changelogItems = useMemo(() => {
    if (loading || !data?.allChangelog?.length) return [];

    return data?.allChangelog?.reduce((acc, logsByDate) => {
      const { date, items } = logsByDate;

      const formattedItems = items.map((item) => ({
        ...item,
        date,
        type: itemTypeMap[item.type],
      }));

      return [...acc, ...formattedItems];
    }, []);
  }, [loading, data]);

  return (
    <Modal
      size="md"
      name={ANNOUNCEMENTS_MODAL_NAME}
      title="Announcements"
      noFooter
      hideCancel
      showCloseButton
      onHide={close}
    >
      <div style={{ maxHeight: 400, overflowY: "auto" }}>
        {loading && (
          <div className="flex justify-center items-center py-6">
            <Spinner variant="primary" size="sm" />
          </div>
        )}
        {!loading && !changelogItems.length && (
          <p className="text-center py-6">No announcements to display</p>
        )}
        {!loading && !!changelogItems.length && (
          <ul className="space-y-4">
            {changelogItems.map((item) => (
              <li key={item.title} className="px-2">
                <div>
                  <div className="flex items-start gap-2">
                    <span
                      className={classNames(
                        "text-white text-xs font-semibold px-2 py-0.5 rounded",
                        {
                          "bg-green-600": item.type === "NEW",
                          "bg-blue-600": item.type === "IMPROVE",
                          "bg-purple-600": item.type === "FIX",
                        },
                      )}
                    >
                      {item.type}
                    </span>
                    <p className="font-medium leading-5 m-0">{item.title}</p>
                  </div>
                  <p className="text-sm text-gray-700 leading-5 mt-1">{item.description}</p>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </Modal>
  );
};

export default AnnouncementsModal;
